"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
const types_1 = require("./types");
class RegularItalicStyle {
    constructor() {
        this.name = types_1.FontStyleName.ITALIC;
        this.style = graphql_schema_types_1.FontStyle.Italic;
        this.weight = 400;
    }
}
exports.default = RegularItalicStyle;
//# sourceMappingURL=RegularItalicStyle.js.map